import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import styles from './PagePanel.module.scss'
import { Loader } from '@/components/ui/loader'

export function PagePanel({ children }: { children: ReactNode }) {
  return <section className={styles.panel}>{children}</section>
}

export function ShellLoadingPanel() {
  return (
    <div className={styles.loader} role="status">
      <Loader variant="blocks" showLabel={false} size="xl" />
    </div>
  )
}

export function RoutePlaceholder({ path }: { path: string }) {
  return (
    <PagePanel>
      <div className={styles.stack}>
        <h2 className={styles.title}>Pagina non trovata</h2>
        <p className={styles.muted}>Il percorso richiesto non esiste.</p>
      </div>
      <p className={styles.mono}>{path}</p>
      <div className={styles.actions}>
        <Button asChild variant="outline" size="sm">
          <Link to="/">Torna alla home</Link>
        </Button>
      </div>
    </PagePanel>
  )
}
